import React from 'react';
import { cn } from '../../lib/utils';

export const CARD_SURFACE_CLASS =
  'rounded-xl border border-slate-200/90 bg-white shadow-[0_4px_16px_rgba(15,23,42,0.08)]';

export function Card({ className, ...props }) {
  return (
    <div
      className={cn(CARD_SURFACE_CLASS, className)}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }) {
  return (
    <div
      className={cn('flex flex-col gap-1.5 border-b border-slate-200 px-4 py-3', className)}
      {...props}
    />
  );
}

export function CardTitle({ className, children, ...props }) {
  return (
    <h3 className={cn('font-display text-sm font-semibold text-[#201C35]', className)} {...props}>
      {children}
    </h3>
  );
}

export function CardDescription({ className, ...props }) {
  return <p className={cn('text-xs leading-5 text-slate-600', className)} {...props} />;
}

export function CardContent({ className, ...props }) {
  return <div className={cn('px-4 py-4', className)} {...props} />;
}

export function CardFooter({ className, ...props }) {
  return <div className={cn('border-t border-slate-100 px-4 py-3', className)} {...props} />;
}
